import { Avatar as AntdAvatar, type AvatarProps } from "antd"
import { cn } from "styles/cn"

export const Avatar = ({
	className,
	children,
	draggable = false,
	...props
}: AvatarProps) => {
	const text =
		typeof children === "string"
			? String(children.charAt(0) || "-").toLowerCase()
			: children
	const backgroundColor =
		typeof text === "string" ? avatarColor[text] : undefined

	return (
		<AntdAvatar
			{...props}
			draggable={draggable}
			style={{ backgroundColor }}
			className={cn(
				"size-6 text-xl text-white uppercase lg:size-11",
				className,
			)}
		>
			{text}
		</AntdAvatar>
	)
}

Avatar.Group = AntdAvatar.Group
const avatarColor: {
	[x: string]: string
} = {
	a: "#5394F5",
	b: "#53BBF5",
	c: "#38D1E5",
	d: "#40E0A9",
	e: "#8E7DFA",
	f: "#E1BF47",
	g: "#F57676",
	h: "#FA8C69",
	i: "#57EBEB",
	j: "#58D8D0",
	k: "#9A7BDB",
	l: "#F68EAD",
	m: "#8894FC",
	n: "#F7C667",
	o: "#D7DF71",
	p: "#C888FA",
	q: "#F07AD6",
	r: "#79E0BB",
	s: "#269A49",
	t: "#7ACEF2",
	u: "#DC8DEF",
	v: "#FFAE63",
	w: "#95E599",
	x: "#76A3F9",
	y: "#E7B07E",
	z: "#81A1F2",
	"-": "#81A1F2",
}
